import { Component } from '@angular/core';
import { Config, ModalController, NavParams } from '@ionic/angular';

import { Columns } from '@telus/d2c-core';

@Component({
  selector: 'telus-column-visibility',
  templateUrl: 'column-visibility.html',
  styleUrls: ['./column-visibility.scss'],
})
export class ColumnVisivilityComponent {
  ios: boolean;

  columns: Columns[] = [];
  pageType: string;
  defaultColumns: Columns[] = [];

  constructor(
    private config: Config,
    public modalCtrl: ModalController,
    public navParams: NavParams
  ) {}

  ionViewWillEnter() {
    this.ios = this.config.get('mode') === `ios`;

    // passed in array of track names that should be excluded (unchecked)
    this.columns = this.navParams.get('columnSelection');
    this.defaultColumns = this.navParams.get('defaultVisibleColumns');
    this.pageType = this.navParams.get('pageType');
  }

  selectAll(check: boolean) {
    // set all to checked or unchecked
    this.columns.forEach((track) => {
      track.visible = check;
    });
  }

  applyFilters() {
    this.dismiss(this.columns);
  }

  dismiss(data?: any) {
    this.modalCtrl.dismiss(data);
  }

  reset() {
    if (['AddressWalklistPage.columns.'].indexOf(this.pageType) > -1) {
      if (this.columns.length === this.defaultColumns.length) {
        this.selectAll(false);
      } else {
        this.columns.forEach((track) => {
          track.visible = this.defaultColumns.find(
            (c) => c.field === track.field
          )
            ? true
            : false;
        });
      }
    } else {
      this.selectAll(false);
    }
  }
}
